import React from 'react';

function DetailContainer({ title, body }) {
  return (
    <>
      <div className="detailTitle">{title}</div>
      <div className="detailBody">
        {body.map((e) => (
          <div className="detailBody-item">{e}</div>
        ))}
      </div>
    </>
  );
}

export default DetailContainer;
